import { UnderlinedLinkButton } from "../../components/buttons";
import { Column, Row, RowApart } from "../../components/general";
import { HalfLabeledInput, LabeledInput } from "../../components/inputs";
import { RedH3 } from "../../components/text";
import colors from "../../constants/colors";
import { Client } from "../../models/client";
import { FaPlus } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";

export const InfoTab = ({
  client,
  setClient,
  showRequiredErrors,
}: {
  client: Client;
  setClient: any;
  showRequiredErrors: boolean;
}) => {
  const clientTypes: { value: Client["kind"]; label: string }[] = [
    { value: "lender", label: "Lender" },
    { value: "agent", label: "Agent" },
    { value: "other", label: "Other" },
  ];

  const additionalEmailTypes: { value: "processor" | "assistant" | "other"; label: string }[] = [
    { value: "processor", label: "Processor" },
    { value: "assistant", label: "Assistant" },
    { value: "other", label: "Other" },
  ];

  return (
    <div>
      <div className="p-field" style={{ marginBottom: 18 }}>
        <label className="p-label">Client type</label>
        <div className="p-radio-group">
          {clientTypes.map((typeOption) => {
            const checked = client.kind === typeOption.value;
            return (
              <button
                key={typeOption.value}
                type="button"
                className={`p-radio${checked ? " checked" : ""}`}
                onClick={() => setClient({ ...client, kind: typeOption.value })}
              >
                <span className="p-radio-dot" />
                <span className="p-radio-label">{typeOption.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <LabeledInput
        value={client.name}
        setValue={(val: any) => setClient({ ...client, name: val })}
        error={showRequiredErrors && !client.name ? "Required." : ""}
      >
        Name
      </LabeledInput>
      <LabeledInput
        value={client.phone}
        setValue={(val: any) => setClient({ ...client, phone: val })}
        error={
          showRequiredErrors
            ? !client.phone
              ? ""
              : client.phone.match(/^\d{3}-\d{3}-\d{4}$/)
              ? ""
              : "Please enter a valid phone number (###-###-####)"
            : ""
        }
      >
        Phone
      </LabeledInput>
      <LabeledInput
        value={client.email}
        setValue={(val: any) => setClient({ ...client, email: val })}
        error={
          showRequiredErrors
            ? !client.email
              ? ""
              : client.email.length < 5 ||
                !client.email.includes("@") ||
                !client.email.includes(".")
              ? "Please enter a valid email"
              : ""
            : ""
        }
      >
        Email
      </LabeledInput>

      <RedH3 style={{ marginTop: 40 }}>Additional Emails</RedH3>

      {(client.additionalEmails || []).map((assistant, index) => (
        <Column
          className="p-subtle-block"
          style={{
            marginTop: 12,
            width: "100%",
          }}
        >
          <Row>
            <HalfLabeledInput
              value={assistant.name}
              inputStyles={{ width: 380, marginRight: 30 }}
              setValue={(val: any) => {
                let additionalEmails = client.additionalEmails;
                additionalEmails[index].name = val;

                setClient({
                  ...client,
                  additionalEmails: additionalEmails,
                });
              }}
            >
              Name
            </HalfLabeledInput>
            <HalfLabeledInput
              value={assistant.email}
              inputStyles={{ width: 380, marginRight: 30 }}
              setValue={(val: any) => {
                let additionalEmails = client.additionalEmails;
                additionalEmails[index].email = val;

                setClient({
                  ...client,
                  additionalEmails: additionalEmails,
                });
              }}
            >
              Email
            </HalfLabeledInput>
          </Row>
          <RowApart style={{ width: "100%", paddingRight: 8, gap: 16, alignItems: "center" }}>
            <div className="p-field" style={{ marginBottom: 0, flex: 1 }}>
              <label className="p-label">Type</label>
              <div className="p-radio-group">
                {additionalEmailTypes.map((typeOption) => {
                  const checked = assistant.kind === typeOption.value;
                  return (
                    <button
                      key={`${index}-${typeOption.value}`}
                      type="button"
                      className={`p-radio${checked ? " checked" : ""}`}
                      onClick={() => {
                        let additionalEmails = client.additionalEmails;
                        additionalEmails[index].kind = typeOption.value;
                        setClient({
                          ...client,
                          additionalEmails: additionalEmails,
                        });
                      }}
                    >
                      <span className="p-radio-dot" />
                      <span className="p-radio-label">{typeOption.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>
            <UnderlinedLinkButton
              style={{ display: "flex", alignItems: "center", height: 42, marginBottom: 0 }}
              onClick={() => {
                setClient({
                  ...client,
                  additionalEmails: client.additionalEmails.filter(
                    (a, i) => i != index
                  ),
                });
              }}
            >
              <FaTrash />
            </UnderlinedLinkButton>
          </RowApart>
        </Column>
      ))}

      <UnderlinedLinkButton
        onClick={() => {
          setClient({
            ...client,
            additionalEmails: client.additionalEmails.concat([
              { name: "", email: "", kind: "other" },
            ]),
          });
        }}
      >
        <FaPlus />
      </UnderlinedLinkButton>
    </div>
  );
};
